import React, { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import DriverInfoHeader from "../../components/PageHeader";

import { saveSessionDriverAddressConfirmation } from "../../services/ValidateDriverAddress";

import { checkDriverInfoStepEditMode } from "./driverInfoStepUtils";

import { DomainContext } from "../../domain-repository/DomainRepository";
import TrackingPage from "../../components/TrackingPage";

const INVALID_ADDRESS_STYLE = {
  color: "gray",
  marginTop: "15px",
  marginLeft: "15px",
};

function DriverInfoInvalidAddressPage(props) {
  const { t } = useTranslation();
  const code = new URLSearchParams(props.location.search).get("code");

  const { driverInfoEditMode, invalidAddressAlert } = useContext(DomainContext);

  function handleChangeAddressClick() {
    props.history.replace('/driver-info-step/3');
  }

  async function handleConfirmAddressClick() {
    await saveSessionDriverAddressConfirmation();
    props.history.push(
      driverInfoEditMode ? "/driver-info-review" : "/driver-info-step/3"
    );
  }

  return (
    <div>
      <DriverInfoHeader
        title={t("personalInfo")}
        active={1}
        progress={"5.55%"}
        handleLogoClick={() => props.history.push("/start")}
      />
      {invalidAddressAlert ? (
        <main>
          <div className="container container-large">
            <div className="main-frame">
              <div className="container">
                <div className="row justify-content-center">
                  {code ? (
                    <div className="col-12 mb-5">
                      <h2 className="title">
                        {t("confirmDoorNumber")}
                      </h2>
                    </div>
                  ) : (
                    <>
                      <div className="col-12 mb-5">
                        <h2 className="title">
                          {t("confirmAddressTitle")}
                        </h2>
                      </div>
                      <div className="col-10 mb-5 text-center">
                        <div>
                          {t("confirmAddressMessage")}{" "}
                          <div style={INVALID_ADDRESS_STYLE}>
                            <li>{invalidAddressAlert}</li>
                          </div>
                        </div>
                      </div>
                    </>
                  )}
                  <div className="container">
                    <div className="row justify-content-center">
                      <div className="col-md-6 col-8">
                        <div
                          onClick={handleConfirmAddressClick}
                          className="btn btn-green w-100 p-3 mb-3"
                        >
                          {t("confirmAddressButton")}
                        </div>
                      </div>
                      <div className="col-md-6 col-8">
                        <div
                          onClick={handleChangeAddressClick}
                          className="btn btn-green w-100 p-3 "
                        >
                          {t("changeAddressButton")}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </main>
      ) : null}
    </div>
  );
}

export default TrackingPage(DriverInfoInvalidAddressPage, 40);
